import { post } from './base'

export function createTenant({ slug, name }) {
  return post('/api/v2/tenants', {
    data: { slug, name },
  })
}
